import {
  setLocalToken,
  deleteLocalToken,
  DMSAccessTokenKey,
  DMSRefreshTokenKey
} from '@/apps/auth/utils'

export default {
  // Set tokens
  SET_TOKENS(state, { access, refresh }) {
    setLocalToken(DMSAccessTokenKey, access)
    setLocalToken(DMSRefreshTokenKey, refresh)
    state.accessToken = access
    state.refreshToken = refresh
  },
  // Delete tokens
  DELETE_TOKENS(state) {
    deleteLocalToken(DMSAccessTokenKey)
    deleteLocalToken(DMSRefreshTokenKey)
    state.accessToken = null
    state.refreshToken = null
  },
  // Set refreshing state
  SET_REFRESHING_CALL(state, value) {
    state.refreshingCall = value
  }
}



// WEBPACK FOOTER //
// ./src/apps/auth/store/mutations.js